import { useEffect, useState } from "react";
import "./SayMyName.css";

const TextRoulette = () => {
    const [name, setName] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const fetchName = () => {
        setIsLoading(true);
        setIsVisible(false);

        fetch("https://saymyname.valou.io/thatsmyname.txt")
            .then((res) => res.text())
            .then((data) => {
                setName(data);
                setIsLoading(false);
                setTimeout(() => setIsVisible(true), 100);
            })
            .catch((err) => {
                console.error("Erreur:", err);
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchName();
    }, []);

    return (
        <div className="text-roulette-container">
            <div>
                {isLoading ? (
                    <div className="loading"> </div>
                ) : (
                    <div className={`fade-in ${isVisible ? "visible" : ""}`}>
                        {name}
                    </div>
                )}
            </div>
        </div>
    );
};

export default TextRoulette;
